"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    using: "This domain is using DigitalOcean DNS.",
    notUsing: "This domain is not using DigitalOcean DNS.",
    learnMore: "Learn more about DigitalOcean DNS.",
    subdomain: "This is a sub-domain and does not have any NS records.",
};
